export enum ProductRefinementGroupings {
	Brand = 0,
	Color = 1,
	Material = 2,
	Print = 3,
	Size = 4,
	Price = 5,
	SkinType = 6,
	Specialities = 7,
	Format = 8,
	Formulation = 9,
	Treatment = 10,
	EditorChoiceIds = 11,
}
